@if (navigation.history?.length > 1) {
  <a
    aria-label="back"
    (click)="navigation.goBack()"
    class="tab-link"
    >
    <mat-icon>arrow_back</mat-icon>
  </a>
}
